import type { PreparedSeries } from "../prepare-series";

type SeriesReading = { timeMs: number; value: number };

/** First index whose time is at or after timeMs. */
function lowerBound(points: PreparedSeries["points"], timeMs: number): number {
    let low = 0;
    let high = points.length;
    while (low < high) {
        const mid = Math.floor((low + high) / 2);
        if (points[mid][0].getTime() < timeMs) low = mid + 1;
        else high = mid;
    }
    return low;
}

/** Nearest reading by time, the rule echarts' tooltip uses, so the two never disagree. */
export function findNearestReading(points: PreparedSeries["points"], timeMs: number): SeriesReading | null {
    if (points.length === 0) return null;

    const at = lowerBound(points, timeMs);
    const before = points[at - 1];
    const after = points[at];

    let nearest = before ?? after;
    if (before && after) {
        const beforeMs = before[0].getTime();
        const afterMs = after[0].getTime();
        nearest = timeMs - beforeMs <= afterMs - timeMs ? before : after;
    }

    const value = nearest[1];
    return value === null ? null : { timeMs: nearest[0].getTime(), value };
}
